<template>
  <div>
    <v-row>
      <v-col cols="12">
        <gg-card-title class="pb-6 pt-0">
          Create New Support Ticket
        </gg-card-title>
        <gg-card>
          <gg-card-header class="mb-5">
            Create New Ticket
          </gg-card-header>
          <gg-card-text>
            <v-form>
              <v-row>
                <v-col cols="12" class="py-0">
                  <gg-select
                    outlined
                    label="Department"
                    v-model="model.department"
                    v-validate="rules.department"
                    :items="departments"
                    data-vv-name="department"
                    data-vv-as="Department"
                    :error-messages="errors.collect('department')"
                  ></gg-select>
                </v-col>
                <v-col cols="12" class="py-0">
                  <gg-text-field
                    outlined
                    label="Subject"
                    v-model="model.subject"
                    v-validate="rules.subject"
                    data-vv-name="subject"
                    data-vv-as="Subject"
                    :error-messages="errors.collect('subject')"
                  ></gg-text-field>
                </v-col>
                <v-col cols="12" class="py-0" v-if="showServices">
                  <gg-select
                    outlined
                    label="Related Service"
                    v-model="model.service"
                    v-validate="isServiceIsRequired"
                    :items="services_items"
                    item-value="id"
                    data-vv-name="service"
                    data-vv-as="Service"
                    :error-messages="errors.collect('service')"
                  >
                    <template slot="selection" slot-scope="{ item }">
                      {{ item.name }} {{ item.domain ? '-' + item.domain : '' }}
                    </template>
                    <template slot="item" slot-scope="{ item }">
                      {{ item.name }} {{ item.domain ? '-' + item.domain : '' }}
                    </template>
                  </gg-select>
                </v-col>
                <v-col cols="12" class="py-0">
                  <contacts v-model="model.contacts"/>
                </v-col>
                <v-col cols="12" class="py-0" id="message">
                  <gg-input-label>Describe your issue here</gg-input-label>
                  <v-textarea
                    outlined
                    class="gg-input"
                    dense
                    :autofocus="messageAutofocus"
                    ref="message"
                    v-model="model.body"
                    v-validate="rules.message"
                    data-vv-name="Message"
                    :error-messages="errors.collect('Message')"
                  >
                  </v-textarea>
                </v-col>
                  <v-col cols="12">
                    <attachments @update="setAttachment"/>
                  </v-col>
                <v-col cols="12">
                  <gg-btn color="primary" tile  :loading="loading" @click="openTicket">Create Ticket</gg-btn>
                </v-col>
              </v-row>
            </v-form>
          </gg-card-text>
        </gg-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Contacts from '@/components/Support/Common/Contacts'
import Attachments from '@/components/Support/Common/Attachments'

export default {
  name: 'TicketNewView',
  components: {
    Contacts,
    Attachments,
  },
  data: () => ({
    model: {
      subject: '',
      service: '',
      department: '',
      contacts: [],
      body: '',
      attachments: '',
    },
    loading: false,
    rules: {
      subject: {
        required: true,
      },
      service: {
        required: true,
      },
      department: {
        required: true,
      },
      contacts: {
        required: true,
        email: true,
      },
      message: {
        required: true,
      },
    },
    departments: ['Billing', 'Sales', 'Support', 'Affiliate Support'],
    services_items: [],
    showGroups: ['Shared Hosting', 'Reseller Hosting', 'Virtual Private Server', 'Dedicated Server'],
  }),
  methods: {
    ...mapActions(['createTicket', 'reportSuccess', 'reportError']),
    serviceList () {
      this.services_items.push({ name: 'Other', id: 'other' })
      this.services.forEach(item => {
        if (this.showGroups.indexOf(item.groupname) !== -1) {
          this.services_items.push(item)
        }
      })
      this.initPrefill()
    },
    setAttachment (payload) {
      this.model.attachments = payload
    },
    async openTicket () {
      try {
        const valid = await this.$validator.validateAll()
        if (!valid) { return }

        this.loading = true
        const data = {
          subject: this.model.subject,
          body: this.model.body,
          department: this.model.department,
          attachments: this.model.attachments,
          service: this.model.service,
          contacts: this.model.contacts,
        }
        const response = await this.createTicket(data)
        this.loading = false

        this.reportSuccess('Ticket was succesfully created.')
        this.$router.push(`/support/ticket/${response.ticketmaskid}`)
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
    initPrefill () {
      const prefillService = this.services_items.find(s => s.id == this.$route.query.s)
      if (prefillService) {
        this.model.service = prefillService.id
      }
      if (this.departments.indexOf(this.$route.query.d) !== -1) {
        this.model.department = this.$route.query.d
      }
      this.model.subject = this.$route.query.sbj
      this.model.body = this.$route.query.msg
    }
  },
  computed: {
    ...mapGetters(['services', 'servicegroups']),
    isServiceIsRequired () {
      return this.services_items.length === 0 ? { required: false } : { required: true }
    },
    messageAutofocus () {
      return !!(this.$route.query.sbj && this.$route.query.d && this.$route.query.s)
    },
    showServices () {
      return this.model.department !== 'Affiliate Support'
    }
  },
  created () {
    this.serviceList()
  },
}
</script>
